import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type { CourtInfo } from '../types';

export function useCounties() {
  return useQuery<string[]>({
    queryKey: ['courts', 'counties'],
    queryFn: async () => {
      const { data } = await api.get('/courts/counties');
      return data.counties;
    },
    staleTime: Infinity,
  });
}

export function useCourtsInCounty(county: string) {
  return useQuery<CourtInfo[]>({
    queryKey: ['courts', 'by-county', county],
    queryFn: async () => {
      const { data } = await api.get('/courts', { params: { county } });
      return data.courts;
    },
    enabled: !!county,
    staleTime: Infinity,
  });
}
